import { ColumnInfo, WebsiteColumnResult } from '../types/rankAList';

export const exampleColumns: ColumnInfo[] = [
  { name: 'company_name', type: 'string', sampleValues: ['Acme Corp', 'TechStart Inc'] },
  { name: 'website', type: 'string', sampleValues: ['acme.com', 'techstart.io'] },
  { name: 'category', type: 'string', sampleValues: ['B2B', 'B2C'] },
  { name: 'revenue', type: 'number', sampleValues: ['1000000', '500000'] },
  { name: 'employees', type: 'number', sampleValues: ['50', '25'] },
  { name: 'location', type: 'string', sampleValues: ['San Francisco', 'New York'] }
];

export const exampleWebsiteResults: WebsiteColumnResult[] = [
  { column: 'website', uniqueCount: 1250 },
  { column: 'company_name', uniqueCount: 980 }
];

export const exampleLabels = ['B2B', 'B2C', 'Enterprise', 'SMB', 'Startup']; 